import React, { lazy } from "react";
import { usePropertyStore } from "properties/propertyPage/PropertyContext";
import { unitTypesStore } from "unitTypes/_store/unitTypesStore";
import { TFilterType } from "admin/_common/resources/ResourceFilterMdl";
import { unitsStore } from "units/_stores/unitsStore";
import { DEFAULT_UNIT_FILTERS } from "_configs/unitFilters";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { combineLoadingStates } from "_common/loaders/loadingStateUtils";
import { PropertyUnitTypeListLoader } from "properties/propertyPage/PropertyUnitTypeListLoader";
import Suspenser from "_common/loaders/Suspenser";

const LazyPropertyInventory = lazy(() => import("properties/propertyPage/inventory/PropertyInventory"));

export const PropertyBuildableHouseAvailableModels = () => {
    const { property } = usePropertyStore();
    const unitTypeListStore = unitTypesStore.getListStore(property._id, Number.MAX_SAFE_INTEGER, [
        { id: "property", type: TFilterType.ID, value: property._id },
    ]);
    const unitListStore = unitsStore.getListStore(
        property._id,
        Number.MAX_SAFE_INTEGER,
        [...DEFAULT_UNIT_FILTERS, { id: "propertyId", type: TFilterType.ID, value: property._id }],
        undefined,
        undefined,
        { floorPosition: 1 },
    );
    return (
        <LoadableFromLoading
            loading={combineLoadingStates([unitTypeListStore.currentLoadingState, unitListStore.currentLoadingState])}
            renderer={() => {
                return (
                    <>
                        <PropertyUnitTypeListLoader />
                        <Suspenser noSpinner noText>
                            <LazyPropertyInventory />
                        </Suspenser>
                    </>
                );
            }}
        />
    );
};
